import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useGetInfo = ()=>{
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const { data: businessInfo, isLoading, optimisticUpdate } = useQueryState({
        queryKey: [
            QueryKeys.GetInfo,
            businessId
        ],
        queryFn: async ()=>await api.business.getInfo(businessId),
        enabled: !!businessId
    });
    return {
        businessId,
        businessInfo,
        isLoading,
        optimisticUpdate
    };
};
